import { routeConstants } from "../constants";
import store, { CoreReduxState } from "../redux/store";

/**
 * Generates a method that will check a combination of routes and
 * custom segments.
 */
export function checkSegments({
  oneOf,
  required,
}: {
  oneOf: (routeConstants | ((state: CoreReduxState) => boolean))[];
  required?: (state?: CoreReduxState) => boolean;
}) {
  const ret = (state = store.getState()) => {
    const { routeId } = state;
    return (
      oneOf.find((check) =>
        typeof check === "function" ? check(state) : check === routeId
      ) &&
      (!required || required(state))
    );
  };
  return ret;
}
